<div class="qr-reader-container">
    <!-- Kamera -->
    <zxing-scanner
      *ngIf="scannerEnabled"
      [device]="selectedDevice"
      (camerasFound)="camerasFoundHandler($event)"
      (scanSuccess)="onCodeResult($event)">
    </zxing-scanner>

    <!-- Beolvasás indító gomb -->
    <button *ngIf="!scannerEnabled" (click)="startScanner()" class="btn scan-btn">
      QR kód beolvasása
    </button>

    <!-- Beolvasott kód -->
    <div *ngIf="scannedCode" class="result">
      <p><strong>Beolvasott kód:</strong> {{ scannedCode }}</p>
    </div>

  <div *ngIf="subscriberCoupons && subscriberCoupons.length > 0">
    <p>Kuponok</p>
    <ul>
      <li *ngFor="let item of subscriberCoupons">{{ item }}</li>
    </ul>
  </div>


    <!-- Vásárlás mező és sorsolás gomb -->
    <div *ngIf="subscriberId && !subscriberUsed" class="form-section">
      <label for="amount">Vásárlás összege (Ft):</label>
      <input
        id="amount"
        type="number"
        [(ngModel)]="purchaseAmount"
        min="1"
        class="input-field"
        placeholder="Pl. 5000" />

      <button (click)="drawGift()" class="btn draw-btn">Sorsolás</button>
    </div>

    <!-- Ajándék eredmény
    <div *ngIf="giftNumber" class="gift-result">
      🎁 <strong>Ajándék sorszám:</strong> {{ giftNumber }}
    </div>-->

    <!-- Ajándék eredmény -->
    <div *ngIf="giftNumber" class="gift-result">
        <img [src]="giftNumber.imgSrc" alt="Ajándék" class="gift-image" />
        <p>{{ giftNumber.name }}</p>
    </div>


    <!-- Kupon már felhasználva -->
    <div *ngIf="subscriberUsed && !giftNumber" class="info used">
      <p>A kuponod ebben a kampányban már felhasználásra került.</p>
      <p>Ne csüggedj, mert hamarosan újra aktiváljuk kuponod és esélyed lehet újabb ajándékra is!</p>
    </div>

    <!-- Hibák -->
    <div *ngIf="error" class="error">
      ⚠️ {{ error }}
    </div>

    <!-- Infó -->
    <div *ngIf="!subscriberUsed && infoMessage && !error" class="info success">
      ✅ {{ infoMessage }}
    </div>
  </div>
